import { render, staticRenderFns } from "./HuaxianAttractCarrier.vue?vue&type=template&id=983e55d4&scoped=true&"
import script from "./HuaxianAttractCarrier.vue?vue&type=script&lang=js&"
export * from "./HuaxianAttractCarrier.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianAttractCarrier.vue?vue&type=style&index=0&id=983e55d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983e55d4",
  null
  
)

export default component.exports